module.exports = __webpack_public_path__ + "img/building-fill.a598bcfc.svg";